import type { IconId, IconProps } from '.';

export const iconsMap: { [key in IconId]: IconProps } = {
  'not-found': {
    originalKey: 'iconoir:file-not-found',
    body: `	<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 8v4m0 4.01l.01-.011M9 3H4v3m0 5v2m16-2v2M15 3h5v3M9 21H4v-3m11 3h5v-3" />`,
  },
  home: {
    originalKey: 'mdi:home',
    body: `<path d="M10 20v-6h4v6h5v-8h3L12 3L2 12h3v8z"/>`,
  },
  account: {
    originalKey: 'mid:account',
    body: `<path d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4" />`,
  },
  delete: {
    originalKey: 'material-symbols:delete',
    body: `<path d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zm2-4h2V8H9zm4 0h2V8h-2z" />`,
  },
  close: {
    originalKey: 'material-symbols:close-rounded',
    body: `<path d="m12 13.4l-4.9 4.9q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7l4.9-4.9l-4.9-4.9q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.9 4.9l4.9-4.9q.275-.275.7-.275t.7.275t.275.7t-.275.7L13.4 12l4.9 4.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275z" />`,
  },
  'menu-open': {
    originalKey: 'mdi:menu-open',
    body: `<path d="M21 15.61L19.59 17l-5.01-5l5.01-5L21 8.39L17.44 12zM3 6h13v2H3zm0 7v-2h10v2zm0 5v-2h13v2z" />`,
  },
  'menu-close': {
    originalKey: 'mdi:menu-close',
    // Horizontal mirror of menu-open: list on the right, chevron on the left pointing right.
    body: `<path d="M3 15.61L4.41 17l5.01-5l-5.01-5L3 8.39L6.56 12zM8 6h13v2H8zm3 7v-2h10v2zm-3 5v-2h13v2z" />`,
  },
  'bars-3': {
    originalKey: 'heroicons:bars-3-16-solid',
    viewBox: { size: 16 },
    body: `<path fill-rule="evenodd" d="M2 3.75A.75.75 0 0 1 2.75 3h10.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 3.75M2 8a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 8m0 4.25a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75" clip-rule="evenodd" />`,
  },
  gear: {
    originalKey: 'material-symbols:garage-home',
    body: `<path d="M4 21V9l8-6l8 6v12h-3V11H7v10zm5-2h6v-2H9zm0-4h6v-2H9z" />`,
  },
  packs: {
    originalKey: 'material-symbols:backpack-rounded',
    body: `<path d="M6 22q-.825 0-1.412-.587T4 20V8q0-1.4.85-2.45T7 4.15V3q0-.425.288-.713T8 2h1q.425 0 .713.288T10 3v1h4V3q0-.425.288-.712T15 2h1q.425 0 .713.288T17 3v1.15q1.3.35 2.15 1.4T20 8v12q0 .825-.587 1.413T18 22zm8.5-8v1q0 .425.288.713T15.5 16t.713-.288T16.5 15v-2q0-.425-.288-.712T15.5 12h-7q-.425 0-.712.288T7.5 13t.288.713T8.5 14z" />`,
  },
  trips: {
    originalKey: 'ph:person-simple-hike-fill',
    viewBox: { size: 256 },
    body: `<path d="M120 48a32 32 0 1 1 32 32a32 32 0 0 1-32-32m72 88c-23.37 0-28.92-8.56-36.6-20.4c-3.65-5.64-7.79-12-14.16-17.55a41 41 0 0 0-8-5.47a8 8 0 0 0-11 3.92L64.66 228.81a8 8 0 0 0 4.15 10.52A7.8 7.8 0 0 0 72 240a8 8 0 0 0 7.34-4.81l33.59-77.27l31.07 22.2V232a8 8 0 0 0 16 0v-56a8 8 0 0 0-3.35-6.51l-37.2-26.57l13.4-30.81c3.57 3.62 6.28 7.8 9.13 12.19c7.67 11.84 16.27 25.11 42 27.36V232a8 8 0 0 0 16 0v-88a8 8 0 0 0-7.98-8M72 152a8 8 0 0 0 7.36-4.85l24-56a8 8 0 0 0-4.2-10.5l-28-12a8 8 0 0 0-10.5 4.2l-24 56a8 8 0 0 0 4.2 10.5l28 12A8 8 0 0 0 72 152" />`,
  },
  email: {
    originalKey: 'mdi:email',
    body: `<path d="m20 8l-8 5l-8-5V6l8 5l8-5m0-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2" />`,
  },
  'check-circle': {
    originalKey: 'mdi:check-circle',
    body: `<path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m-2 15l-5-5l1.41-1.41L10 14.17l7.59-7.59L19 8z" />`,
  },
  'backpack-outline': {
    originalKey: 'material-symbols:backpack-outline-rounded',
    body: `<path fill="currentColor" d="M6 22q-.825 0-1.412-.587T4 20V8q0-1.4.85-2.45T7 4.15V3q0-.425.288-.713T8 2h1q.425 0 .713.288T10 3v1h4V3q0-.425.288-.712T15 2h1q.425 0 .713.288T17 3v1.15q1.3.35 2.15 1.4T20 8v12q0 .825-.587 1.413T18 22zm0-2h12V8q0-.825-.587-1.412T16 6H8q-.825 0-1.412.588T6 8zm8.5-6v1q0 .425.288.713T15.5 16t.713-.288T16.5 15v-2q0-.425-.288-.712T15.5 12h-7q-.425 0-.712.288T7.5 13t.288.713T8.5 14zM12 13" />`,
  },
  backpack: {
    originalKey: 'app:backpack',
    // 97.57 42.93 316.86 390.36
    viewBox: { minY: 0, minX: 0, width: 512, height: 512 },
    body: `    
<path
  d="M256.196 123.621c-19.094 0-34.607-15.502-34.607-34.18 0-19.076 15.514-34.582 34.607-34.582 18.702 0 34.211 15.506 34.211 34.582 0 18.678-15.509 34.18-34.211 34.18zm0-80.689c-25.857 0-46.544 20.667-46.544 46.509 0 25.445 20.687 46.111 46.544 46.111 25.461 0 46.151-20.667 46.151-46.111.001-25.842-20.69-46.509-46.151-46.509z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#47413d" />
<path
  d="M183.398 290.183v143.112h-6.764c-15.514 0-29.838-5.564-40.979-15.112-13.927-11.529-22.279-29.014-22.279-48.096v-71.152c0-4.767 3.583-8.752 8.752-8.752h61.27zM399.814 298.935v71.152c0 19.082-8.355 36.566-22.277 48.096-11.144 9.548-25.465 15.112-40.979 15.112h-6.769V290.183h61.274c4.771 0 8.751 3.985 8.751 8.752z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#d29362" />
<path
  d="M404.583 301.712H107.408v-29.023c0-7.544 6.367-13.91 14.321-13.91h268.533c7.956 0 14.32 6.366 14.32 13.91v29.023z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#5baa73" />
<path style="fill-rule:evenodd;clip-rule:evenodd;fill:#75b198" d="M399.415 301.712h5.168v5.16h-5.168z" />
<path
  d="M413.737 329.938c-5.967-5.563-9.154-13.518-9.154-21.464v-6.763h-5.168v8.751c0 8.341 3.179 15.901 9.149 21.858l1.191 1.19c.799.79 1.991 1.192 3.184.79 1.595-.788 1.991-2.776.798-4.362z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#e08e58" />
<path
  d="M404.583 308.475v-17.101c3.586 0 6.365 2.794 6.365 6.368v4.767c0 3.172-2.779 5.966-6.365 5.966zM107.408 308.475v-17.101c-3.577 0-6.365 2.794-6.365 6.368v4.767c0 3.172 2.788 5.966 6.365 5.966z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#883e2d" />
<path
  d="M98.26 329.938c5.97-5.563 9.148-13.518 9.148-21.464v-6.763h5.175v8.751c0 8.341-3.181 15.901-9.148 21.858l-1.192 1.19c-.803.79-1.994 1.192-3.187.79-1.59-.788-1.989-2.776-.796-4.362z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#e08e58" />
<path
  d="M379.921 168.146v239.698c0 3.574-.798 7.166-2.384 10.338-3.981 9.154-13.134 15.112-23.479 15.112H157.935c-10.342 0-19.49-5.958-23.471-15.112-1.591-3.172-2.385-6.764-2.385-10.338V168.146c0-44.127 35.806-79.896 79.958-79.896h87.918c44.161 0 79.966 35.77 79.966 79.896z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#e6be8b" />
<path
  d="M379.921 160.599v5.957c0 3.575-.798 7.149-2.384 10.342-3.981 9.133-13.134 15.103-23.479 15.103H157.935c-10.342 0-19.49-5.97-23.471-15.103-1.192-3.192-2.385-6.767-2.385-10.342v-5.957c0-44.123 35.806-79.51 79.958-79.51l87.918-.399c44.161 0 79.966 35.787 79.966 79.909z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#5baa73" />
<path
  d="M372.363 162.982v3.575c-.398-42.138-34.612-76.322-76.38-76.322h-83.946c-30.234 0-56.488 17.49-68.823 42.935-1.986 4.368-3.577 8.341-4.77 13.119-1.199 4.368-2.391 9.134-2.788 13.916.397-5.576 1.192-11.135 2.385-16.299 1.199-3.985 2.391-7.958 4.379-11.533 11.538-27.031 38.587-45.713 69.617-45.713h83.946c42.163 0 76.38 34.184 76.38 76.322z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#47413d" />
<path
  d="m148.389 155.422-2.391 1.191c-.797.797-1.988 0-2.784-1.191l-4.371-10.325-.398-1.192 2.385-6.368 8.354 14.709c.397 1.192.397 2.782-.795 3.176z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#47413d" />
<path
  d="m143.214 144.699 1.192 2.382c.398 1.192.398 1.989-.396 2.383-.796.399-1.59 0-2.385-.793l-1.193-2.383c-.396-1.191 0-1.984.397-2.383.796-.41 1.988 0 2.385.794z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#dcdfe1" />
<path
  d="M197.72 269.517c-5.173 0-9.155-4.372-9.155-9.547V105.737c5.969-1.984 11.939-3.176 18.703-3.575V259.97c0 5.175-4.38 9.547-9.548 9.547zM312.688 269.517c5.174 0 9.149-4.372 9.149-9.547V126.802c-5.971-1.59-12.336-2.383-18.696-2.782v135.95c.001 5.175 4.372 9.547 9.547 9.547z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#47413d" />
<path
  d="M209.652 253.614H186.18c-3.583 0-6.364-2.777-6.364-6.368v-7.149c0-3.571 2.781-6.352 6.364-6.352h23.473c3.187 0 5.969 2.781 5.969 6.352v7.149c-.001 3.59-2.783 6.368-5.97 6.368z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#a87e2b" />
<path
  d="M209.652 250.04H186.18c-3.583 0-6.364-2.794-6.364-5.97v-7.544c0-3.192 2.781-5.974 6.364-5.974h23.473c3.187 0 5.969 2.781 5.969 5.974v7.544c-.001 3.176-2.783 5.97-5.97 5.97z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#e9a820" />
<path
  d="M213.632 252.028c-1.994-.798-3.979-1.192-5.968-1.989h1.988c3.187 0 5.969-2.794 5.969-5.97v3.176c0 2.002-.797 3.591-1.989 4.783z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#a5762a" />
<path
  d="M325.818 253.614h-23.075c-3.582 0-6.365-2.777-6.365-6.368v-7.149c0-3.571 2.783-6.352 6.365-6.352h23.075c3.577 0 6.365 2.781 6.365 6.352v7.149c.001 3.59-2.787 6.368-6.365 6.368z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#a87e2b" />
<path
  d="M325.818 250.04h-23.075c-3.582 0-6.365-2.794-6.365-5.97v-7.544c0-3.192 2.783-5.974 6.365-5.974h23.075c3.577 0 6.365 2.781 6.365 5.974v7.544c.001 3.176-2.787 5.97-6.365 5.97z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#e9a820" />
<path
  d="M330.189 252.028c-1.986-.798-3.977-1.192-5.966-1.989h1.595c3.577 0 6.365-2.794 6.365-5.97v3.176c.001 2.002-.793 3.591-1.994 4.783z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#a5762a" />
<path
  d="M188.564 192.001V84.277c5.969-1.603 12.336-2.794 18.703-3.188v110.912h-18.703zM321.838 192.001V83.866c-5.971-1.586-12.336-2.777-18.696-2.777v110.912h18.696z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#47413d" />
<path
  d="M315.074 274.282H197.317c-12.33 0-22.278 9.942-22.278 22.269v91.03c0 12.326 9.948 22.253 22.278 22.253h117.757c12.331 0 21.879-9.927 21.879-22.253v-91.03c0-12.326-9.548-22.269-21.879-22.269z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#d29362" />
<path
  d="M175.039 370.49v17.091c0 12.326 9.948 22.253 22.278 22.253h117.757c12.331 0 21.879-9.927 21.879-22.253V370.49H175.039z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#8e4b3d" />
<path
  d="M331.789 310.463c0 1.586-1.6 2.777-3.191 2.777h-145.2c-1.596 0-2.788-1.191-2.788-2.777 0-1.988 1.192-3.18 2.788-3.18h145.199c1.592 0 3.192 1.192 3.192 3.18z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#47413d" />
<path
  d="M195.329 335.896h-6.368c-2.384 0-4.768-1.988-4.37-4.766l1.986-21.062v-2.785h11.143v2.785l1.988 21.062c0 2.777-1.988 4.766-4.379 4.766z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#47413d" />
<path
  d="M195.726 313.24v5.169a3.57 3.57 0 0 1-3.577 3.582 3.573 3.573 0 0 1-3.584-3.582v-5.169a3.566 3.566 0 0 1 3.584-3.574 3.564 3.564 0 0 1 3.577 3.574z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#dcdfe1" />
<path
  d="M271.707 401.493h-31.425c-2.384 0-4.77-1.988-4.77-4.766v-13.123c0-2.391 2.386-4.379 4.77-4.379l31.425-.396c2.792 0 4.777 2.385 4.777 4.775v13.123c0 2.778-1.985 4.766-4.777 4.766z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#e9a820" />
<path style="fill-rule:evenodd;clip-rule:evenodd;fill:#fefefe" d="M243.866 385.198h25.061v9.532h-25.061z" />
<path style="fill-rule:evenodd;clip-rule:evenodd;fill:#47413d"
  d="M243.866 385.198v9.532h1.592v-7.551h21.878v7.551h1.591v-9.532zM290.407 153.039c0 .797-.789 1.191-1.587 1.191h-65.643c-.796 0-1.192-.395-1.192-1.191 0-.793.396-1.586 1.192-1.586h65.643c.798 0 1.587.793 1.587 1.586z" />
<path
  d="M228.749 164.572h-3.187c-1.192 0-1.987-1.192-1.987-2.383l1.191-9.544v-1.191h4.778v1.191l1.192 9.544c.001 1.191-.795 2.383-1.987 2.383z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#47413d" />
<path
  d="M228.749 154.23v2.383c0 .797-.796 1.59-1.597 1.59-.794 0-1.59-.793-1.59-1.59v-2.383c0-.793.796-1.586 1.59-1.586.801.001 1.597.794 1.597 1.586z"
  style="fill-rule:evenodd;clip-rule:evenodd;fill:#dcdfe1" />
`,
  },
  'sign-in': {
    originalKey: 'mdi:sign-in',
    body: `<path d="M11 7L9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5zm9 12h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8z" />`,
  },
  'sign-out': {
    originalKey: 'mdi:sign-out',
    body: `<path d="m17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5M4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4z" />`,
  },
  'circle-outline': {
    originalKey: 'mdi:circle-outline',
    body: `<path d="M12 20a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2" />`,
  },
  'alert-circle-outline': {
    originalKey: 'mdi:alert-circle-outline',
    body: `<path d="M11 15h2v2h-2zm0-8h2v6h-2zm1-5C6.47 2 2 6.5 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8" />`,
  },
  'check-circle-outline': {
    originalKey: 'mdi:alert-circle-outline',
    body: `<path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4l8-8z" />`,
  },
  'arrow-right': {
    originalKey: 'mdi:arrow-right',
    body: `<path d="M4 11v2h12l-5.5 5.5l1.42 1.42L19.84 12l-7.92-7.92L10.5 5.5L16 11z" />`,
  },
  'eye-outline': {
    originalKey: 'mdi:eye-outline',
    body: `<path d="M12 9a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m0-4.5c5 0 9.27 3.11 11 7.5c-1.73 4.39-6 7.5-11 7.5S2.73 16.39 1 12c1.73-4.39 6-7.5 11-7.5M3.18 12a9.821 9.821 0 0 0 17.64 0a9.821 9.821 0 0 0-17.64 0" />`,
  },
  'eye-off-outline': {
    originalKey: 'mdi:eye-off-outline',
    body: `<path d="M2 5.27L3.28 4L20 20.72L18.73 22l-3.08-3.08c-1.15.38-2.37.58-3.65.58c-5 0-9.27-3.11-11-7.5c.69-1.76 1.79-3.31 3.19-4.54zM12 9a3 3 0 0 1 3 3a3 3 0 0 1-.17 1L11 9.17A3 3 0 0 1 12 9m0-4.5c5 0 9.27 3.11 11 7.5a11.8 11.8 0 0 1-4 5.19l-1.42-1.43A9.86 9.86 0 0 0 20.82 12A9.82 9.82 0 0 0 12 6.5c-1.09 0-2.16.18-3.16.5L7.3 5.47c1.44-.62 3.03-.97 4.7-.97M3.18 12A9.82 9.82 0 0 0 12 17.5c.69 0 1.37-.07 2-.21L11.72 15A3.064 3.064 0 0 1 9 12.28L5.6 8.87c-.99.85-1.82 1.91-2.42 3.13" />`,
  },
  'register-outline': {
    originalKey: 'mdi:register-outline',
    body: `<path d="M15 4a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4m0 1.9a2.1 2.1 0 1 1 0 4.2A2.1 2.1 0 0 1 12.9 8A2.1 2.1 0 0 1 15 5.9M4 7v3H1v2h3v3h2v-3h3v-2H6V7zm11 6c-2.67 0-8 1.33-8 4v3h16v-3c0-2.67-5.33-4-8-4m0 1.9c2.97 0 6.1 1.46 6.1 2.1v1.1H8.9V17c0-.64 3.1-2.1 6.1-2.1" />`,
  },
  'google-logo': {
    // viewBox="0 0 256 262"
    originalKey: 'logos:google-icon',
    viewBox: { minY: 0, minX: 0, width: 256, height: 262 },
    body: `
<path fill="#4285f4" d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622l38.755 30.023l2.685.268c24.659-22.774 38.875-56.282 38.875-96.027" />
<path fill="#34a853" d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055c-34.523 0-63.824-22.773-74.269-54.25l-1.531.13l-40.298 31.187l-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1" />
<path fill="#fbbc05" d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82c0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602z" />
<path fill="#eb4335" d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0C79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251" />
`,
  },
  sun: {
    originalKey: 'mdi:weather-sunny',
    body: `<path d="M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3m0-7l2.39 3.42C13.65 5.15 12.84 5 12 5s-1.65.15-2.39.42zM3.34 7l4.16-.35A7.2 7.2 0 0 0 5.94 8.5c-.44.74-.69 1.5-.83 2.29zm.02 10l1.76-3.77a7.1 7.1 0 0 0 .83 2.28c.47.76 1.07 1.39 1.76 1.89zM20.65 7l-1.77 3.79a7.02 7.02 0 0 0-2.58-4.19zm-.01 10l-4.14.36c.59-.51 1.12-1.14 1.55-1.88c.46-.75.71-1.53.86-2.33zM12 22l-2.41-3.44c.74.27 1.55.44 2.41.44c.82 0 1.63-.17 2.37-.44z" />`,
  },
  moon: {
    originalKey: 'mdi:weather-night',
    body: `<path d="M17.75 4.09L15.22 6.03l.95 3.09l-2.63-1.81l-2.63 1.81l.95-3.09l-2.53-1.94h3.12L13.5 1l1.05 3.09zm3.75 7.41a7 7 0 0 1-7 7c-2.79 0-5.2-1.64-6.32-4a7.006 7.006 0 0 0 10.82-5.88c0-.49-.05-.97-.15-1.43A6.97 6.97 0 0 1 21.5 11.5" />`,
  },
  monitor: {
    originalKey: 'mdi:monitor',
    body: `<path d="M21 16H3V4h18m0-2H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h7v2H8v2h8v-2h-2v-2h7a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2" />`,
  },
  'credit-card': {
    originalKey: 'mdi:credit-card-outline',
    body: `<path d="M20 8H4V6h16m0 12H4v-6h16m0-8H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2" />`,
  },
  'help-circle': {
    originalKey: 'mdi:help-circle-outline',
    body: `<path d="M11 18h2v-2h-2zm1-16A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m0-14a4 4 0 0 0-4 4h2a2 2 0 0 1 2-2a2 2 0 0 1 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5a4 4 0 0 0-4-4" />`,
  },
  'account-cog': {
    originalKey: 'mdi:account-cog-outline',
    body: `<path d="M10 4a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4m0 2a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m7 6q-.24 0-.24.24l-.26 1.26c-.22.18-.54.34-.78.5l-1.28-.5c-.08 0-.24 0-.32.1l-.96 1.76c-.08.08-.08.24.08.32l1.04.82v1l-1.04.82c-.08.08-.16.24-.08.32l.96 1.76c.08.1.24.1.32.1l1.28-.5c.24.16.56.32.78.5l.26 1.26q0 .24.24.24h2c.08 0 .24-.08.24-.24l.16-1.26c.32-.18.64-.34.88-.5l1.22.5c.14 0 .3 0 .3-.1l1.04-1.76c.08-.08 0-.24-.08-.32l-1.04-.82v-1l1.04-.82c.08-.08.16-.24.08-.32L21.8 13.6c0-.1-.16-.1-.3-.1l-1.22.5c-.24-.16-.56-.32-.88-.5l-.16-1.26c0-.16-.16-.24-.24-.24zm-7 1c-2.67 0-8 1.33-8 4v3h9.67c-.28-.59-.48-1.23-.58-1.9H3.9V17c0-.64 3.13-2.1 6.1-2.1c.43 0 .87.04 1.3.1c.2-.64.47-1.24.82-1.79c-.78-.13-1.52-.21-2.12-.21m8.04 2.5c.8 0 1.46.66 1.46 1.54c0 .8-.66 1.46-1.46 1.46c-.88 0-1.54-.66-1.54-1.46c0-.88.66-1.54 1.54-1.54" />`,
  },
  'ellipsis-horizontal': {
    originalKey: 'heroicons:ellipsis-horizontal-20-solid',
    viewBox: { size: 20 },
    body: `<path d="M3 10a1.5 1.5 0 1 1 3 0a1.5 1.5 0 0 1-3 0m5.5 0a1.5 1.5 0 1 1 3 0a1.5 1.5 0 0 1-3 0m5.5 0a1.5 1.5 0 1 1 3 0a1.5 1.5 0 0 1-3 0" />`,
  },
  'spinner-circle-outline': {
    originalKey: 'svg-spinners:ring-resize',
    body: `
	<g stroke="currentColor" stroke-width="1">
		<circle cx="12" cy="12" r="9" fill="none" stroke-linecap="round" stroke-width="2">
			<animate attributeName="stroke-dasharray" calcMode="spline" dur="2.1s" keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1" keyTimes="0;0.475;0.95;1" repeatCount="indefinite" values="0 150;42 150;42 150;42 150" />
			<animate attributeName="stroke-dashoffset" calcMode="spline" dur="2.1s" keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1" keyTimes="0;0.475;0.95;1" repeatCount="indefinite" values="0;-16;-59;-59" />
		</circle>
		<animateTransform attributeName="transform" dur="2.8s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12" />
	</g>
    `,
  },
  settings: {
    originalKey: 'material-symbols:settings-outline',
    body: `<path d="M9.25 22l-.4-3.2q-.325-.125-.612-.3t-.563-.375L4.7 19.375l-2.75-4.75l2.575-1.95Q4.5 12.5 4.5 12.338v-.675q0-.163.025-.338L1.95 9.375l2.75-4.75l2.975 1.25q.275-.2.575-.375t.6-.3l.4-3.2h5.5l.4 3.2q.325.125.613.3t.562.375l2.975-1.25l2.75 4.75l-2.575 1.95q.025.175.025.338v.674q0 .163-.05.338l2.575 1.95l-2.75 4.75l-2.95-1.25q-.275.2-.575.375t-.6.3l-.4 3.2zm2.8-6.5q1.45 0 2.475-1.025T15.55 12t-1.025-2.475T12.05 8.5q-1.475 0-2.488 1.025T8.55 12t1.013 2.475T12.05 15.5"/>`,
  },
  check: {
    originalKey: 'mdi:check',
    body: `<path d="M21 7L9 19l-5.5-5.5l1.41-1.41L9 16.17L19.59 5.59z"/>`,
  },
  sliders: {
    originalKey: 'mdi:slider',
    body: `<path d="M8 13c-1.86 0-3.41 1.28-3.86 3H2v2h2.14c.45 1.72 2 3 3.86 3s3.41-1.28 3.86-3H22v-2H11.86c-.45-1.72-2-3-3.86-3m0 6c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2M19.86 6c-.45-1.72-2-3-3.86-3s-3.41 1.28-3.86 3H2v2h10.14c.45 1.72 2 3 3.86 3s3.41-1.28 3.86-3H22V6zM16 9c-1.1 0-2-.9-2-2s.9-2 2-2s2 .9 2 2s-.9 2-2 2"/>`,
  },
  'chevron-down': {
    originalKey: 'mdi:chevron-down',
    body: `<path d="M7.41 8.58L12 13.17l4.59-4.59L18 10l-6 6l-6-6z"/>`,
  },
  'chevron-left': {
    originalKey: 'mdi:chevron-left',
    body: `<path d="M15.41 16.58L10.83 12l4.58-4.59L14 6l-6 6l6 6z"/>`,
  },
  'chevron-right': {
    originalKey: 'mdi:chevron-right',
    body: `<path d="M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6z"/>`,
  },
  'expand-all': {
    originalKey: 'mdi:chevron-up-down',
    body: `<path d="M12 18.17L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15M12 5.83L15.17 9l1.41-1.41L12 3L7.41 7.59L8.83 9z"/>`,
  },
  'collapse-all': {
    originalKey: 'mdi:chevron-down-up',
    body: `<path d="M16.59 5.41L15.17 4L12 7.17L8.83 4L7.41 5.41L12 10m-4.59 8.59L8.83 20L12 16.83L15.17 20l1.41-1.41L12 14z"/>`,
  },
  drag: {
    originalKey: 'mdi:drag',
    body: `<path d="M7 19v-2h2v2zm4 0v-2h2v2zm4 0v-2h2v2zm-8-4v-2h2v2zm4 0v-2h2v2zm4 0v-2h2v2zm-8-4V9h2v2zm4 0V9h2v2zm4 0V9h2v2zM7 7V5h2v2zm4 0V5h2v2zm4 0V5h2v2z"/>`,
  },
  star: {
    originalKey: 'material-symbols:star-rounded',
    body: `<path fill="currentColor" d="m12 17.275l-4.15 2.5q-.275.175-.575.15t-.525-.2t-.35-.437t-.05-.588l1.1-4.725L3.775 10.8q-.25-.225-.312-.513t.037-.562t.3-.45t.55-.225l4.85-.425l1.875-4.45q.125-.3.388-.45t.537-.15t.537.15t.388.45l1.875 4.45l4.85.425q.35.05.55.225t.3.45t.038.563t-.313.512l-3.675 3.175l1.1 4.725q.075.325-.05.588t-.35.437t-.525.2t-.575-.15z"/>`,
  },
  'star-outline': {
    originalKey: 'material-symbols:star-outline-rounded',
    body: `<path fill="currentColor" d="m8.85 16.825l3.15-1.9l3.15 1.925l-.825-3.6l2.775-2.4l-3.65-.325l-1.45-3.4l-1.45 3.375l-3.65.325l2.775 2.425zm3.15.45l-4.15 2.5q-.275.175-.575.15t-.525-.2t-.35-.437t-.05-.588l1.1-4.725L3.775 10.8q-.25-.225-.312-.513t.037-.562t.3-.45t.55-.225l4.85-.425l1.875-4.45q.125-.3.388-.45t.537-.15t.537.15t.388.45l1.875 4.45l4.85.425q.35.05.55.225t.3.45t.038.563t-.313.512l-3.675 3.175l1.1 4.725q.075.325-.05.588t-.35.437t-.525.2t-.575-.15zm0-5.025"/>`,
  },
  share: {
    originalKey: 'mdi:share-variant',
    body: `<path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81a3 3 0 0 0 3-3a3 3 0 0 0-3-3a3 3 0 0 0-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9a3 3 0 0 0-3 3a3 3 0 0 0 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65a2.92 2.92 0 0 0 2.92 2.92A2.92 2.92 0 0 0 21 18.92A2.92 2.92 0 0 0 18 16.08"/>`,
  },
  camera: {
    originalKey: 'mdi:camera',
    body: `<path d="M4 4h3l2-2h6l2 2h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m8 3a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5m0 2a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3"/>`,
  },
  copy: {
    originalKey: 'mdi:content-copy',
    body: `<path d="M19 21H8V7h11m0-2H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m-3-4H4a2 2 0 0 0-2 2v14h2V3h12z"/>`,
  },
  link: {
    originalKey: 'mdi:link-variant',
    body: `<path d="M10.59 13.41c.41.39.41 1.03 0 1.42c-.39.39-1.03.39-1.42 0a5.003 5.003 0 0 1 0-7.07l3.54-3.54a5.003 5.003 0 0 1 7.07 0a5.003 5.003 0 0 1 0 7.07l-1.49 1.49c.01-.82-.12-1.64-.4-2.42l.47-.48a2.98 2.98 0 0 0 0-4.24a2.98 2.98 0 0 0-4.24 0l-3.53 3.53a2.98 2.98 0 0 0 0 4.24m2.82-4.24c.39-.39 1.03-.39 1.42 0a5.003 5.003 0 0 1 0 7.07l-3.54 3.54a5.003 5.003 0 0 1-7.07 0a5.003 5.003 0 0 1 0-7.07l1.49-1.49c-.01.82.12 1.64.4 2.42l-.47.48a2.98 2.98 0 0 0 0 4.24a2.98 2.98 0 0 0 4.24 0l3.53-3.53a2.98 2.98 0 0 0 0-4.24c-.41-.41-.41-1.03 0-1.42"/>`,
  },
  'open-in-new': {
    originalKey: 'mdi:open-in-new',
    body: `<path d="M14 3v2h3.59l-9.83 9.83l1.41 1.41L19 6.41V10h2V3m-2 16H5V5h7V3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7h-2z"/>`,
  },
  download: {
    originalKey: 'mdi:download',
    body: `<path d="M5 20h14v-2H5m14-9h-4V3H9v6H5l7 7z"/>`,
  },
  import: {
    originalKey: 'mdi:import',
    // MDI's import glyph draws within y:[4,20] in a 24x24 box — only 16 of 24
    // units tall — so it renders ~15% smaller than siblings like share
    // (y:[2,22]) and sliders (y:[3,21]) at the same em size. Tighten the
    // viewBox to a 20-unit square centered on the content so the icon scales
    // up to match its neighbors.
    viewBox: { size: 20, minX: 1, minY: 2 },
    body: `<path d="M14,12L10,8V11H2V13H10V16M20,18V6C20,4.89 19.1,4 18,4H6A2,2 0 0,0 4,6V9H6V6H18V18H6V15H4V18A2,2 0 0,0 6,20H18A2,2 0 0,0 20,18Z"/>`,
  },
  plus: {
    originalKey: 'mdi:plus',
    body: `<path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"/>`,
  },
  code: {
    originalKey: 'mdi:code-tags',
    body: `<path d="M14.6 16.6l4.6-4.6l-4.6-4.6L16 6l6 6l-6 6zm-5.2 0L4.8 12l4.6-4.6L8 6l-6 6l6 6z"/>`,
  },
  search: {
    originalKey: 'material-symbols:search',
    body: `<path d="M15.5 14h-.79l-.28-.27A6.47 6.47 0 0 0 16 9.5A6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5S14 7.01 14 9.5S11.99 14 9.5 14"/>`,
  },
  refresh: {
    originalKey: 'mdi:refresh',
    body: `<path d="M17.65 6.35A7.96 7.96 0 0 0 12 4a8 8 0 0 0-8 8a8 8 0 0 0 8 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z"/>`,
  },
  feedback: {
    originalKey: 'mdi:bullhorn-outline',
    body: `<path d="M12 8H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h1v4a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-4h3l5 4V4zm3 9.6L11 14H4v-4h7l4-3.6zm3.5-7.6c1.2.8 2 2.1 2 3.5c0 1.5-.7 2.8-1.9 3.6l-1.1-1.6c.7-.4 1-1.2 1-2c0-.8-.4-1.6-1-2z"/>`,
  },
  bug: {
    originalKey: 'mdi:bug-outline',
    body: `<path d="M20 8h-2.81c-.45-.8-1.07-1.5-1.82-2L17 4.41L15.59 3l-2.17 2.17a6 6 0 0 0-2.83 0L8.41 3L7 4.41L8.62 6c-.75.5-1.36 1.21-1.81 2H4v2h2.09c-.06.33-.09.66-.09 1v1H4v2h2v1c0 .34.03.67.09 1H4v2h2.81A5.99 5.99 0 0 0 15 20.18c.91-.52 1.67-1.28 2.19-2.18H20v-2h-2.09c.06-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.03-.67-.09-1H20zm-4 7a4 4 0 0 1-4 4a4 4 0 0 1-4-4v-4a4 4 0 0 1 4-4a4 4 0 0 1 4 4zm-2-5v2h-4v-2zm-4 4h4v2h-4z"/>`,
  },
  lightbulb: {
    originalKey: 'mdi:lightbulb-outline',
    body: `<path d="M12 2a7 7 0 0 1 7 7c0 2.38-1.19 4.47-3 5.74V17a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2.26C6.19 13.47 5 11.38 5 9a7 7 0 0 1 7-7M9 21v-1h6v1a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1m3-17a5 5 0 0 0-5 5c0 2.05 1.23 3.81 3 4.58V16h4v-2.42c1.77-.77 3-2.53 3-4.58a5 5 0 0 0-5-5"/>`,
  },
  help: {
    originalKey: 'mdi:help',
    body: `<path d="M10 19h3v3h-3zm2-17c5.35.22 7.68 5.62 4.5 9.67c-.83 1-2.17 1.66-2.83 2.5C13 15 13 16 13 17h-3c0-1.67 0-3.08.67-4.08c.66-1 2-1.59 2.83-2.25C15.92 8.43 15.32 5.26 12 5a3 3 0 0 0-3 3H6a6 6 0 0 1 6-6"/>`,
  },
  'list-bulleted': {
    originalKey: 'mdi:format-list-bulleted',
    body: `<path fill="currentColor" d="M7 5h14v2H7zm0 8v-2h14v2zM4 4.5A1.5 1.5 0 0 1 5.5 6A1.5 1.5 0 0 1 4 7.5A1.5 1.5 0 0 1 2.5 6A1.5 1.5 0 0 1 4 4.5m0 6A1.5 1.5 0 0 1 5.5 12A1.5 1.5 0 0 1 4 13.5A1.5 1.5 0 0 1 2.5 12A1.5 1.5 0 0 1 4 10.5M7 19v-2h14v2zm-3-2.5A1.5 1.5 0 0 1 5.5 18A1.5 1.5 0 0 1 4 19.5A1.5 1.5 0 0 1 2.5 18A1.5 1.5 0 0 1 4 16.5"/>`,
  },
  italic: {
    originalKey: 'mdi:format-italic',
    body: `<path fill="currentColor" d="M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z"/>`,
  },
};
